const fmtItems = (order) => (order.items || []).map((it) => {
  const qty = Number(it.quantity || 1);
  if (it.selections?.length) {
    const kind = it.type === "economy" ? "Economy" : "Build Your Box";
    const sel = it.selections.map((s) => `${s.flavor_name || "Flavour"} ${s.base || ""} ${s.boost_label || "Standard"} x${s.quantity || 1}`.replace(/\s+/g, " ").trim()).join("; ");
    return `${kind} ${it.size_label || ""} x${qty} [${sel}]`;
  }
  const name = [it.brand_name, it.name || it.flavor_name || it.label || it.type].filter(Boolean).join(" ");
  const opts = (it.options || []).map((o) => o.label).filter(Boolean).join("+");
  return `${name} ${it.size_label || ""} x${qty}${opts ? ` (${opts})` : ""}`.replace(/\s+/g, " ").trim();
}).join(" | ");

const COLUMNS = [
  ["Order", (o) => o.order_number],
  ["Placed", (o) => (o.created_at ? new Date(o.created_at).toLocaleString("en-GB") : "")],
  ["Customer", (o) => o.customer_name],
  ["Email", (o) => (o.email && !o.email.endsWith("@telegram.dreamlabs.uk") && !o.email.endsWith("@checkout.dreamlabs.uk") ? o.email : "")],
  ["Channel", (o) => (o.email?.endsWith("@telegram.dreamlabs.uk") ? "Telegram" : "Website")],
  ["Trade", (o) => (o.is_wholesale ? "yes" : "")],
  ["Partner", (o) => o.affiliate?.brand_name || ""],
  ["Items", fmtItems],
  ["Subtotal", (o) => o.subtotal],
  ["Discount code", (o) => o.discount?.code?.code || ""],
  ["Discount", (o) => o.discount?.amount ?? ""],
  ["Shipping", (o) => o.shipping],
  ["Total", (o) => o.total],
  ["Currency", (o) => o.currency],
  ["Payment", (o) => o.payment_status],
  ["BTCPay status", (o) => [o.btcpay_status, o.btcpay_additional_status !== "None" ? o.btcpay_additional_status : ""].filter(Boolean).join(" / ")],
  ["Fulfilment", (o) => o.fulfillment_status],
  ["Tracking", (o) => o.tracking_number || ""],
  ["Ships to", (o) => o.shipping_zone || ""],
  ["Weight g", (o) => o.total_weight_g ?? ""],
  ["Partner commission", (o) => o.affiliate?.commission_amount ?? ""],
  ["Combined payment", (o) => o.payment_group_number || ""],
];

const cell = (v) => {
  const s = v === null || v === undefined ? "" : String(v);
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

export const ordersToCsv = (orders) =>
  [COLUMNS.map(([h]) => h).join(","), ...orders.map((o) => COLUMNS.map(([, f]) => cell(f(o))).join(","))].join("\r\n");

export const downloadOrdersCsv = (orders, name = "dreamlabs-orders") => {
  const blob = new Blob(["\ufeff" + ordersToCsv(orders)], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${name}-${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};
